import {request} from "../config/axios";

export const loginApi = (data) => request('post', 'login', {data});
export const logoutApi = (data) => request('get', 'logout', {data});
export const registerApi = (data) => request('post', 'register', {data});
export const checkSessionApi = (data) => request('get', 'checkSession', {data});



// WEBPACK FOOTER //
// ./src/api/login.js